/**
 * Editorial-dash template that creates a Question instance configured for
 * collecting audience submissions.
 *
 * Templates are creation-time presets, not runtime features: this file
 * registers a `SpaceTemplate` in the `templates` config slot so it appears as a
 * tile in the new-space picker, and on create the dashboard enables the
 * `audience_input` feature, which gives its comments an upvote in place of
 * emoji reactions. Once the instance
 * exists, this template no longer runs — the actual conversation behavior comes
 * from the features it toggled.
 */

import type { SpaceTemplate } from 'feature/editorial-dash/spaces';
import { t } from 'util/stdtypes';

export const AudienceInputTemplate: SpaceTemplate = {
    key: 'audience-input',
    label: t('audience_input_template.label', 'Audience Input'),
    descriptionLabel: t(
        'audience_input_template.description',
        'Collect questions, testimonials, and stories from users. This allows for a greater range of engagement.',
    ),
    imageUrl: 'images/audience-input.svg',
    structureKey: 'question',
    featuresEnabled: ['audience_input'],
};
